<template>
  <div class="loader-container d-flex justify-content-center align-items-center">
    <font-awesome-icon icon="spinner" size="3x" spin />
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Loader',
  components: {
    FontAwesomeIcon
  }
}
</script>

<style lang="scss" scoped>
.loader-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/Loader.vue